//* Libraries imports
import { motion } from 'framer-motion';

//* Components imports
import { Button, Badge, Card } from 'react-bootstrap';
import Icon from "../../../../components/common/Icon";

//* Icons imports
import { BsArrowLeft, BsCalendarFill } from "react-icons/bs";
import { MdOutlineSchool, MdInfo } from 'react-icons/md';

//? Styles imports
import './view-header-process.scss';

type ViewHeaderProcessProps = {
  processName: string | undefined;
  handleBack: () => void;
  isOnline: boolean | undefined;
  startDate?: string;
  endDate?: string;
  collegeName?: string;
  subtitleText?: string;
  basicInfoTitleText?: string;
  startDateLabel?: string;
  endDateLabel?: string;
  collegeNameLabel?: string;
}

export function ViewHeaderProcess(props: ViewHeaderProcessProps) {
  const {
    processName,
    handleBack,
    isOnline,
    startDate,
    endDate,
    collegeName,
    subtitleText = "Informações do Processo Seletivo",
    basicInfoTitleText = "Sobre o Processo",
    startDateLabel = "Data de Início",
    endDateLabel = "Data de Término",
    collegeNameLabel = "Instituição"
  } = props;
  
  return (
    <motion.section
      className="pt-4 p-2 view-header-process-section"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="d-flex justify-content-between align-items-center mb-4 process-details-header">
        <div className="d-flex align-items-center">          <Button
            variant="light"
            className="me-3 rounded-circle p-2 lh-1 back-button"
            onClick={handleBack}
            style={{ width: "40px", height: "40px" }}
          >
            <Icon icon={BsArrowLeft} size={18} />
          </Button>
          <div>
            <motion.h2
              className="fs-1 fw-bold mb-0 process-title"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              {processName}
            </motion.h2>
            <p className="text-muted small mb-0 process-subtitle">
              {subtitleText}
            </p>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <Badge
            bg={isOnline ? "success" : "warning"}
            className="px-3 py-2 fs-6 status-badge"
          >
            {isOnline ? "Online" : "Presencial"}
          </Badge>
        </div>
      </div>

      <Card className="shadow-sm mb-4 info-card">          <Card.Header className="bg-light">
          <h5 className="mb-0">
            <Icon icon={MdInfo} className="me-2 icon" /> {basicInfoTitleText}
          </h5>
        </Card.Header>
        <Card.Body>
          <div className="info-grid">            <div className="info-item">
              <div className="info-header">
                <Icon icon={BsCalendarFill} className="info-icon" />
                <span className="info-label">{startDateLabel}</span>
              </div>
              <div className="info-value">{startDate || "Não informada"}</div>
            </div>
            <div className="info-item">
              <div className="info-header">
                <Icon icon={BsCalendarFill} className="info-icon" />
                <span className="info-label">{endDateLabel}</span>
              </div>
              <div className="info-value">{endDate || "Não informada"}</div>
            </div>            <div className="info-item">
              <div className="info-header">
                <Icon icon={MdOutlineSchool} className="info-icon" />{" "}
                <span className="info-label">{collegeNameLabel}</span>
              </div>
              <div className="info-value">{collegeName || "Não informada"}</div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </motion.section>
  );
}
